/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-20 18:42:17
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-21 23:27:13
 * @FilePath: /mooctest.com/src/api/competition.js
 */
// 班级相关api
import request from "../utils/request";
import { t } from "../i18n/i18n";
// 获取大赛列表
export function competitionDescriptionGet(competitionId) {
  return request({
    url: `/competition/description/${competitionId}`,
    method: "GET",
  });
}

// 学生端大赛列表
export function stuCompetitionListGet() {
  return request({
    url: "/competition",
    method: "GET",
  });
}

// 学生端获取一个大赛信息
export function stuCompetitionGet(competitionId) {
  return request({
    url: `/competition/${competitionId}`,
    method: "GET",
  });
}

// 学生报名大赛
export function enterCompetition(competitionId) {
  return request({
    url: `competition/enter/${competitionId}`,
    method: "POST",
  });
}

// 学生退出大赛
export function quitCompetition(competitionId) {
  return request({
    url: `/competition/quit/${competitionId}`,
    method: "POST",
  });
}

// 修改团队成员
export function updateTeammates(qualificationId, teammateList) {
  return request({
    url: `competition/addons/${qualificationId}/1`,
    method: "POST",
    data: teammateList,
    otherOptions: {
      showLoading: true,
      loadingSetting: {
        text: t("common.saving"),
      },
    },
  });
}

// 修改指导老师
export function updateMentor(qualificationId, mentorList) {
  return request({
    url: `competition/addons/${qualificationId}/0`,
    method: "POST",
    data: mentorList,
    otherOptions: {
      showLoading: true,
      loadingSetting: {
        text: t("common.saving"),
      },
    },
  });
}
